/* eslint-disable no-underscore-dangle */

import design from '@99designs/common/apps/ddo/models/design';
import user from 'apps/ddo/models/user';
import propertyOrNull from '@99designs/common/utils/app/propertyOrNull';

// Translate from HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    const data = {
        designId: propertyOrNull(json, 'design_id'),
        projectDesignId: propertyOrNull(json, 'projectDesignId'),
        creator: user.fromJSON(json._embedded.creator),
        permission: json._embedded.permission || {},
        showUrl: propertyOrNull(json._links.showUrl, 'href'),
        likes: json.likes || [],
        links: {
            self: propertyOrNull(json._links.self, 'href'),
            delete: propertyOrNull(json._links.delete, 'href'),
            comments: propertyOrNull(json._links.comments, 'href'),
            createComment: propertyOrNull(json._links.createComment, 'href'),
            toggleDeliverable: propertyOrNull(json._links.toggleDeliverable, 'href'),
            inviteToWorkUrl: propertyOrNull(json._links.inviteToWorkUrl, 'href'),
            profileUrl: propertyOrNull(json._links.profileUrl, 'href'),
            likeDesignUrl: propertyOrNull(json._links.likeDesignUrl, 'href'),
            editDesignUrl: propertyOrNull(json._links.editDesignUrl, 'href'),
            contestUrl: propertyOrNull(json._links.contestUrl, 'href'),
            lastSeenTimeUrl: propertyOrNull(json._links.lastSeenTimeUrl, 'href'), // this will no longer be used once Profiles adopts the React-Flux implementation for online statuses
            lastSeenTimesUrl: propertyOrNull(json._links.lastSeenTimesUrl, 'href'),
            designLikesUrl: propertyOrNull(json._links.designLikesUrl, 'href'),
        },
    };

    const keys = [
        'name',
        'isDeleted',
        'size',
        'width',
        'height',
        's3Bucket',
        's3Object',
        'createdAt',
        'previewUrl',
        'showUrl',
        'likeCount',
        'likedByUser',
        'shareData',
        'description',
        'categoryEntryInfo',
        'tags',
        'marketingCtaButton',
        'dataFavoriteDesignerUrl',
        'login_or_signup',
    ];

    keys.forEach(k => {
        data[k] = propertyOrNull(json, k);
    });

    return data;
}

// Replace the fromJSON implementation with our own
export default Object.assign({}, design, { fromJSON });



// WEBPACK FOOTER //
// ./src/js/apps/ddo/models/design.js